/**
 * Shared formatting utilities for system status components
 */

export const formatBalance = (balance: number): string => {
  return balance.toFixed(2);
};

export const formatEthBalance = (balance: number): string => {
  return balance.toFixed(4);
};

export const formatTimestamp = (timestamp: string): string => {
  return new Date(timestamp).toLocaleString();
};

export const formatSecondsSince = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s ago`;
  } else if (seconds < 3600) {
    return `${Math.floor(seconds / 60)}m ago`;
  } else {
    return `${Math.floor(seconds / 3600)}h ago`;
  }
};

export const formatLastBeat = (lastBeat: string): string => {
  const date = new Date(lastBeat);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 60) {
    return `${diffSec}s ago`;
  } else if (diffSec < 3600) {
    return `${Math.floor(diffSec / 60)}m ago`;
  } else {
    return `${Math.floor(diffSec / 3600)}h ago`;
  }
};

export const formatSecondsSinceLastBeat = (seconds: number | null): string => {
  if (seconds === null) return "Never";
  return formatSecondsSince(seconds);
};

export const truncateAddress = (address: string): string => {
  return `[${address.toLowerCase().slice(0, 6)}...${address.toLowerCase().slice(-4)}]`;
};

export const truncateHash = (hash: string): string => {
  return `${hash.toLowerCase().slice(0, 6)}...${hash.toLowerCase().slice(-4)}`;
};
